import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';
import bind from 'bind-decorator';
import { StyleCollection } from '../../types';
import { generateCssClasses } from '../../utils/generate-css-classes';
import { isInStorybook } from '../../utils/is-in-storybook';

@Component({
	shadow: true,
	styleUrl: 'zds-backdrop.scss',
	tag: 'zds-backdrop',
})
export class ZdsBackdrop {
	isInStorybook: boolean;

	@Prop() show: boolean;
	@Prop() zIndex: number;

	@Event({ bubbles: true }) zdsBackdropClosed: EventEmitter<MouseEvent | KeyboardEvent>;

	@bind
	backdropClicked(event: MouseEvent) {
		this.zdsBackdropClosed.emit(event);
	}

	@bind
	onKeyDown(event: KeyboardEvent) {
		if (event.key === 'Escape') {
			this.zdsBackdropClosed.emit(event);
		}
	}

	componentWillLoad() {
		document.addEventListener('keydown', this.onKeyDown);
		this.isInStorybook = isInStorybook();
	}

	disconnectedCallback() {
		document.removeEventListener('keydown', this.onKeyDown);
	}

	renderCloseIcon() {
		return (
			<div class="zds-backdrop--close">
				<slot name="close" />
			</div>
		);
	}

	render() {
		const backdropClasses = generateCssClasses('zds-backdrop', {
			hide: !this.show,
			storybook: this.isInStorybook,
		});

		const backdropStyles: StyleCollection = {
			zIndex: this.zIndex?.toString(),
		};

		return (
			<div class={backdropClasses} onClick={this.backdropClicked} style={backdropStyles}>
				{this.renderCloseIcon()}
			</div>
		);
	}
}
